import $ from 'jquery';
import UI from 'root/ui';
import Cache from 'root/cache';
import Modals from 'root/modals';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    events: {
        'click .session-toggle'     : 'onToggleSession',
        'click .console-log-toggle' : 'onToggleConsoleLog',
        'click .block-edit'         : 'onEditBlockRule',
        'click .ignore-edit'        : 'onEditIgnoreRule',
        'click .mask-edit'          : 'onEditMaskRule'
    },

    dom_handlers: {
        onToggleSession: function(e) {
            var domain = $(e.currentTarget).data('val');
            var switch_on = $(e.currentTarget).hasClass('switch-off');

            if (switch_on) {
                $(e.currentTarget).removeClass('switch-off').addClass('switch-on');
            } else {
                $(e.currentTarget).removeClass('switch-on').addClass('switch-off');
            }

            Cache.app.request({
                action: 'project_domain/toggleSessionReplay',
                data: {
                    domain: domain,
                    session_replay: switch_on
                },
                success: () => {
                    if (switch_on) {
                        UI.success('Session replay turned on for ' + domain + '.');
                    } else {
                        UI.success('Session replay turned off for ' + domain + '.');
                    }

                    Cache.project_domain.findWhere({domain: domain}).set('session_replay', switch_on);
                }
            });
        },

        onToggleConsoleLog: function(e) {
            var log_type = $(e.currentTarget).data('val');
            var model = Cache.session_recording_rule.findWhere({rule_type: 'console', selector: log_type});

            if (model) {
                $(e.currentTarget).addClass('switch-off').removeClass('switch-on');

                Cache.app.request({
                    action: 'session_recording_rule/delete',
                    data: {
                        rule_type: 'console',
                        selector: log_type
                    },
                    success: () => {
                        Cache.session_recording_rule.remove(model);
                    }
                });
            } else {
                $(e.currentTarget).addClass('switch-on').removeClass('switch-off');

                Cache.app.request({
                    action: 'session_recording_rule/add',
                    data: {
                        rule_type: 'console',
                        selector: log_type
                    },
                    success: (response) => {
                        Cache.session_recording_rule.add(response);
                    }
                });
            }

            UI.success('Dev Tools settings updated!');
        },

        onEditBlockRule: function(e) {
            Modals.editSessionRecordingRule('block');
        },

        onEditIgnoreRule: function(e) {
            Modals.editSessionRecordingRule('ignore');
        },

        onEditMaskRule: function(e) {
            Modals.editSessionRecordingRule('mask');
        }
    },

    initialize: function() {
        this.listenTo(Cache.session_recording_rule, 'add',    this.renderPrivacyRules);
        this.listenTo(Cache.session_recording_rule, 'remove', this.renderPrivacyRules);
        this.listenTo(Cache.session_recording_rule, 'change', this.renderPrivacyRules);
        this.listenTo(Cache.session_recording_rule, 'reset',  this.renderPrivacyRules);
    },

    renderDomains: function() {
        var domain_options = '';
        var project_domains = [];

        // get a list of unique domains
        Cache.project_domain.each((model) => {
            if (project_domains.indexOf(model.escape('domain')) === -1) {
                project_domains.push(model.get('domain'));
            }
        });

        project_domains.forEach((domain, index) => {
            // when there is one domain turned on, it is turned on
            var is_session_replay_on = Cache.project_domain.findWhere({domain: domain, session_replay: true}) ? true : false;

            domain_options +=
            '<div class="flex-between">' +
                '<div class="font-weight-medium">' + Util.htmlEntities(domain) + '</div>' +
                '<div><button type="button" class="session-toggle small ' + (is_session_replay_on ? 'switch-on' : 'switch-off') + '" data-val="' + Util.htmlEntities(domain) + '"' + (Cache.account.hasFeature('full_session_recording') ? '' : ' disabled') + '></button></div>' +
            '</div>' +
            (index < project_domains.length ?
            '<hr class="small">' : '');
        });

        var html =
        '<p class="margin-bottom-16">Turn Full Session Replay on or off for your domains. Explore more options in the <a href="https://docs.userback.io/docs/javascript-sdk#section-session-replay" class="primary font-weight-medium" target="help" rel="noopener">JavaScript SDK <i class="fa-solid fa-square-arrow-up-right"></i></a>.</p>' +
        '<div class="box-small-large overflow-auto" style="max-height:400px;min-height:330px;">' + (domain_options || '<div class="text-info flex-c" style="min-height:330px;">No project domains created yet</div>') + '</div>';

        this.$el.find('.region-domains').html(html);
    },

    renderPrivacyRules: function() {
        var html = '';
        if (Cache.account.hasFeature('privacy_masking')) {
            // project_id: 0 is the account wide rule
            var rule_block  = Cache.session_recording_rule.findWhere({rule_type: 'block'});
            var rule_ignore = Cache.session_recording_rule.findWhere({rule_type: 'ignore'});
            var rule_mask   = Cache.session_recording_rule.where({rule_type: 'mask'});

            var rule_mask_selectors = '';
            rule_mask.forEach((rule) => {
                rule_mask_selectors += '<div class="code-selector">' + rule.get('selector') + '</div>';
            });

            html =
            '<p class="margin-bottom-16">Use these rules to exclude elements from your session replays.</p>' +
            '<div class="box-small-large overflow-auto" style="max-height:400px;">' +
                '<div class="grid-5-7 margin-bottom-24 padding-bottom-12 solid-line-bottom">' +
                    '<div class="text-info font-weight-medium">Selector</div>' +
                    '<div class="text-info font-weight-medium">Rule</div>' +
                '</div>' +

                '<div class="grid-5-7 margin-bottom-32">' +
                    '<div>' +
                        '<div class="code-selector">' + (rule_block ? rule_block.get('selector') : '.userback-block') + '</div>' +
                        '<div class="userback-block-sample"></div>' +
                    '</div>' +
                    '<div class="flex-between">' +
                        '<div>' +
                            '<span class="badge-secondary-invert font-weight-medium">Block</span>' +
                            '<div class="text-info text-medium margin-top-4">For blocked elements, the element itself and its child elements will be completely ignored by recording.</div>' +
                        '</div>' +
                        '<div class="padding-left-12">' +
                            '<button type="button" class="block-edit small square round text-action"><i class="fa-solid fa-gear"></i></button>' +
                        '</div>' +
                    '</div>' +
                '</div>' +

                '<div class="grid-5-7 margin-bottom-32">' +
                    '<div>' +
                    '<div class="code-selector">' + (rule_ignore ? rule_ignore.get('selector') : '.userback-ignore') + '</div>' +
                        '<div class="userback-ignore-sample"></div>' +
                    '</div>' +
                    '<div class="flex-between">' +
                        '<div>' +
                            '<span class="badge-secondary-invert font-weight-medium">Ignore</span>' +
                            '<div class="text-info text-medium margin-top-4">For ignored elements, the element\'s styling will be preserved, but all the user inputs will be ignored.</div>' +
                        '</div>' +
                        '<div class="padding-left-12">' +
                            '<button type="button" class="ignore-edit small square round text-action"><i class="fa-solid fa-gear"></i></button>' +
                        '</div>' +
                    '</div>' +
                '</div>' +

                '<div class="grid-5-7">' +
                    '<div>' +
                        (rule_mask_selectors || (
                            '<div class="code-selector">input[type="email"]</div>' +
                            '<div class="code-selector">input[type="password"]</div>'
                        )) +
                        '<div class="userback-mask-sample"></div>' +
                    '</div>' +
                    '<div class="flex-between">' +
                        '<div>' +
                            '<span class="badge-secondary-invert font-weight-medium">Mask</span>' +
                            '<div class="text-info text-medium margin-top-4">For masked elements containing text, all text will be replaced by irreversibly-transformed placeholder text, meant to resemble a wireframe of the original content.</div>' +
                        '</div>' +
                        '<div class="padding-left-12">' +
                            '<button type="button" class="mask-edit small square round text-action"><i class="fa-solid fa-gear"></i></button>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>';
        } else {
            html =
            '<p>Exclude elements you want to mask from session replays. <a class="primary font-weight-medium" href="https://support.userback.io/en/articles/5209239-configure-your-project-settings#h_a2ef634d1e" target="help" rel="noopener">Learn more <i class="fa-solid fa-square-arrow-up-right"></i></a></p>' +
            '<div class="box-small-medium">' +
                '<div class="box-neutral"><img width="100%" src="/image/privacy_masking.png"></div>' +
                '<div class="text-align-center margin-top-12">' +
                    '<button class="account-upgrade medium shiny"><span>Upgrade</span></button>' +
                '</div>' +
            '</div>';
        }

        this.$el.find('.region-privacy-rules').html(html);
    },

    renderConsoleLogs: function() {
        var log_types = ['log', 'error', 'warn', 'info', 'debug', 'network'];
        var console_rules = {};

        log_types.forEach((log_type) => {
            if (Cache.session_recording_rule.findWhere({rule_type: 'console', selector: log_type})) {
                console_rules[log_type] = true;
            } else {
                console_rules[log_type] = false;
            }
        });

        var html =
        '<p class="margin-bottom-16">Automatically capture browser console logs & network requests.</p>' +
        '<div class="box-small-large grid-gap-16" style="max-height:400px;">' +
            '<div class="flex-between">' +
                '<div class="font-weight-medium">Log <span class="text-small text-info text-code">console.log(...)</span></div>' +
                '<div><button type="button" class="console-log-toggle small ' + (console_rules.log ? 'switch-on' : 'switch-off') + '" data-val="log"></button></div>' +
            '</div>' +
            '<div class="flex-between">' +
                '<div class="font-weight-medium">Warning <span class="text-small text-info text-code">console.warn(...)</span></div>' +
                '<div><button type="button" class="console-log-toggle small ' + (console_rules.warn ? 'switch-on' : 'switch-off') + '" data-val="warn"></button></div>' +
            '</div>' +
            '<div class="flex-between">' +
                '<div class="font-weight-medium">Info <span class="text-small text-info text-code">console.info(...)</span></div>' +
                '<div><button type="button" class="console-log-toggle small ' + (console_rules.info ? 'switch-on' : 'switch-off') + '" data-val="info"></button></div>' +
            '</div>' +
            '<div class="flex-between">' +
                '<div class="font-weight-medium">Debug <span class="text-small text-info text-code">console.debug(...)</span></div>' +
                '<div><button type="button" class="console-log-toggle small ' + (console_rules.debug ? 'switch-on' : 'switch-off') + '" data-val="debug"></button></div>' +
            '</div>' +
            '<div class="flex-between">' +
                '<div class="font-weight-medium">Error <span class="text-small text-info text-code">console.error(...)</span><span class="text-small text-info"> && JavaScript runtime errors</span></div>' +
                '<div><button type="button" class="console-log-toggle small ' + (console_rules.error ? 'switch-on' : 'switch-off') + '" data-val="error"></button></div>' +
            '</div>' +
            '<div class="flex-between">' +
                '<div class="font-weight-medium">Network Requests <span class="text-small text-info text-code">CSS, JS, Img, Font, XHR...etc</span></div>' +
                '<div><button type="button" class="console-log-toggle small ' + (console_rules.network ? 'switch-on' : 'switch-off') + '" data-val="network"></button></div>' +
            '</div>' +
        '</div>';

        this.$el.find('.region-console-logs').html(html);
    },

    render: function() {
        var content =
        '<div class="tab">' +
            '<div class="tab-menu">' +
                '<a href="#" class="active">Domains</a>' +
                '<a href="#">Privacy Rules</a>' +
                '<a href="#">Dev Tools</a>' +
            '</div>' +
            '<div class="tab-content">' +
                '<div class="region-domains active">' +
                '</div>' +
                '<div class="region-privacy-rules">' +
                '</div>' +
                '<div class="region-console-logs">' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        this.renderDomains();
        this.renderPrivacyRules();
        this.renderConsoleLogs();

        return this;
    }
});